import { PhoneIcon, EmailIcon, LocationIcon } from './Icons';

const Footer = ({ logoSrc }) => {
  return (
    <footer>
      <div className="container">
        <div className="footer__top">
          <div className="footer__col1">
            <a
              href="#top"
              className="footer__logo"
              aria-label="PaveMend – go to top"
            >
              <img
                id="footerLogoImg"
                className="footer__logo-img"
                src={logoSrc}
                alt="PaveMend logo"
              />
            </a>
            <p className="footer__brand-text">
              London's trusted specialists: precision craftsmanship in
              driveways, patios, decking and fencing — across South East London:
              Sidcup, Lewisham, Bromley, Bexley, Greenwich, Orpington and
              beyond.
            </p>
            <div className="footer__contact">
              <a href="tel:+447462911383">
                <PhoneIcon width="16" height="16" />
                07462 911 383
              </a>
              <a href="mailto:hello@pavemend.co.uk">
                <EmailIcon width="16" height="16" />
                hello@pavemend.co.uk
              </a>
              <a
                href="https://maps.google.com/?q=77+Maidstone+Rd,+Foots+Cray,+Sidcup+DA14+5HB"
                target="_blank"
                rel="noreferrer"
              >
                <LocationIcon width="16" height="16" />
                77 Maidstone Rd, Foots Cray, Sidcup, DA14 5HB
              </a>
            </div>
          </div>

          <div className="footer__col2">
            <p className="footer__col-title">Services</p>
            <ul className="footer__col-links">
              <li>
                <a href="/#services">Paving</a>
              </li>
              <li>
                <a href="/#services">Driveways</a>
              </li>
              <li>
                <a href="/#services">Decking</a>
              </li>
              <li>
                <a href="/#services">Natural Stone Patios</a>
              </li>
              <li>
                <a href="/#services">Composite Decking</a>
              </li>
              <li>
                <a href="/#services">Fencing</a>
              </li>
            </ul>
          </div>

          <div className="footer__col3">
            <p className="footer__col-title">Company</p>
            <ul className="footer__col-links">
              <li>
                <a href="/#why">About Us</a>
              </li>
              <li>
                <a href="/#gallery">Our Work</a>
              </li>
              <li>
                <a href="/faq">FAQ</a>
              </li>
              <li>
                <a href="/booking">Book Now</a>
              </li>
            </ul>
          </div>

          <div className="footer__col4">
            <p className="footer__col-title">Areas We Cover</p>
            <ul className="footer__col-links">
              <li>
                <a href="/#contact">SE London</a>
              </li>
              <li>
                <a href="/#contact">Sidcup</a>
              </li>
              <li>
                <a href="/#contact">Lewisham</a>
              </li>
              <li>
                <a href="/#contact">Bromley</a>
              </li>
              <li>
                <a href="/#contact">Bexley</a>
              </li>
              <li>
                <a href="/#contact">Greenwich</a>
              </li>
              <li>
                <a href="/#contact">Orpington</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© 2026 PaveMend. All rights reserved.</span>
          <span>Registration No.: 17335800</span>
          <span>
            <a href="/privacy-policy">Privacy Policy</a>
            {' · '}
            <a href="/terms-of-service">Terms of Service</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
